import React from 'react';
import loc from 'owa-localize';
import { observer } from 'owa-mobx-react';
import { Button, makeStyles } from '@fluentui/react-components';
import { suggestionsLoading } from './SuggestionsPlaceholder.locstring.json';
import { suggestionButtonStyles } from './suggestionButton.styles';
import type { CopilotDabEntrypoint } from 'owa-copilot-telemetry/lib/types/scenarios/CopilotDabTypes';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Placeholder to show while a set of app-specific suggestions are loading.
 *
 * Uses the shared `suggestionButtonStyles` for visual consistency with `SuggestionButton`,
 * but implements its own `Button` component to avoid bundle size overhead from importing
 * `SuggestionButton`. User interaction is disabled via CSS `pointer-events: none`.
 */
export const SuggestionsPlaceholder: React.FC<{
    getEntrypoint: () => CopilotDabEntrypoint;
    mailboxInfo: MailboxInfo;
}> = observer(() => {
    const { button, listItem } = useStyles();

    return (
        <li className={listItem}>
            <Button className={button}>{loc(suggestionsLoading)}</Button>
        </li>
    );
}, 'SuggestionsPlaceholder');

const useStyles = makeStyles({
    button: {
        ...suggestionButtonStyles,
        // Disable pointer events to prevent clicks
        pointerEvents: 'none',
    },

    listItem: {
        textAlign: 'right',
    },
});
